import type { ReactElement } from "react";
import { Link } from "react-router";

import { usePageMeta } from "../../app/use-page-meta.js";
import { FormSummary, TextField } from "../../forms/fields.js";
import { useApiForm } from "../../forms/use-api-form.js";

import { accountApi, accountUrls } from "./urls.js";
import { accountOf, useSignedInOnly } from "./use-signed-in-only.js";

/** 最後の確認はブラウザの確認ダイアログで行う（重要な操作は最後にダイアログで確かめる。2026-10-10 に利用者が決めた）。 */
export const disableTwoFactorDialog = (email: string | undefined): string =>
    `${accountOf(email)}の二段階認証を解除します。今お使いの認証アプリの登録は使えなくなり、次回のログイン時に登録をやり直します。よろしいですか？`;

/**
 * 二段階認証の解除。<b>本人であることをパスワードで確かめる</b>——
 * 押すだけで解除できると、席を離れた端末から二段目を付け替えられる。
 */
export function DisableTwoFactorPage(): ReactElement {
    usePageMeta("二段階認証の解除");
    const email = useSignedInOnly();
    const form = useApiForm(accountApi.disableTwoFactor, undefined, disableTwoFactorDialog(email));

    return (
        <div className="page max-w-md">
            <div className="panel">
                <h1 className="page-title">二段階認証の解除</h1>
                <p className="page-lead">いま登録されている認証アプリを切り離します。</p>

                <div className="panel-message mb-5">
                    <p>
                        解除しても、二段階認証は無効になりません。
                        <b>次回のログイン時に、認証アプリへの登録をやり直していただきます。</b>
                        今お使いの認証アプリの登録は使えなくなります。
                    </p>
                </div>

                <form method="post" noValidate onSubmit={form.onSubmit}>
                    <FormSummary messages={form.summary} />

                    <TextField
                        label="パスワード" name="Password" type="password" required
                        autoComplete="current-password" autoFocus
                        wrapperClassName="mb-7"
                        error={form.fieldError("Password")}
                    />

                    <div className="flex gap-3">
                        <Link to={accountUrls.settings} className="btn-secondary">キャンセル</Link>
                        <button type="submit" className="btn-danger grow" disabled={form.busy}>解除する</button>
                    </div>
                </form>
            </div>
        </div>
    );
}
